import React, { useEffect } from 'react';
import {
  Box,
  Typography,
  Grid,
  Link,
  IconButton,
  Button,
  useTheme,
  Stack
} from '@mui/material';
import { FaFacebookF, FaInstagram, FaTiktok, FaWhatsapp } from 'react-icons/fa';
import { motion } from 'framer-motion';

export default function ContactPage() {
  const theme = useTheme();

  useEffect(() => {
    document.title = 'Contactos | Hydroluz';
    window.scrollTo(0, 0);
  }, []);

  const primaryBlue = '#003366';
  const accentOrange = '#FF9900';

  return (
    <Box sx={{ bgcolor: '#fff', px: { xs: 2, md: 8 }, py: { xs: 6, md: 12 } }}>
      <motion.div
        initial={{ opacity: 0, y: -40 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <Box textAlign="center" sx={{ mb: 5 }}>
          <Typography
            variant="h3"
            sx={{
              fontWeight: 800,
              color: primaryBlue,
              mb: 1,
              fontSize: {
                xs: '1.8rem',
                md: '2.5rem',
              },
            }}
          >
            ¡Hablemos! Estamos para servirte
          </Typography>
          <Typography variant="h6" sx={{ color: '#555' }}>
            Atención rápida, soporte experto y los mejores productos.
          </Typography>
        </Box>
      </motion.div>

      <Grid
        container
        spacing={{ xs: 2, md: 1 }}
        justifyContent="center"
        alignItems="center"
      >
        <Grid item xs={12} md={4.5}>
          <Stack spacing={4}>
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.2, duration: 0.6 }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: primaryBlue }}>
                Correo electrónico
              </Typography>
              <Link
                href="mailto:ventas@hydroluz.com.ec"
                underline="none"
                sx={{ color: '#000', fontSize: '1rem' }}
              >
                ventas@hydroluz.com.ec
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.4, duration: 0.6 }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: primaryBlue }}>
                Teléfono / WhatsApp
              </Typography>
              <Link
                href="https://wa.me/593991911882"
                target="_blank"
                rel="noopener"
                underline="none"
                sx={{ color: '#000', fontSize: '1rem' }}
              >
                +593 99 191 1882
              </Link>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.6, duration: 0.6 }}
            >
              <Typography variant="subtitle1" sx={{ fontWeight: 700, color: primaryBlue, mb: 1 }}>
                Síguenos en redes
              </Typography>
              <Stack direction="row" spacing={2}>
                <IconButton component="a" href="https://facebook.com" target="_blank" sx={{ color: primaryBlue }}>
                  <FaFacebookF />
                </IconButton>
                <IconButton component="a" href="https://instagram.com" target="_blank" sx={{ color: '#E1306C' }}>
                  <FaInstagram />
                </IconButton>
                <IconButton component="a" href="https://tiktok.com" target="_blank" sx={{ color: '#000' }}>
                  <FaTiktok />
                </IconButton>
                <IconButton component="a" href="https://wa.me/593991911882" target="_blank" sx={{ color: '#25D366' }}>
                  <FaWhatsapp />
                </IconButton>
              </Stack>
            </motion.div>
          </Stack>
        </Grid>

        <Grid
          item
          xs={12}
          md={4.5}
          display="flex"
          flexDirection="column"
          alignItems={{ xs: 'center', md: 'flex-start' }}
          justifyContent="center"
        >
          <motion.div style={{ width: '100%' }}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <Box textAlign={{ xs: 'center', md: 'left' }}>
              <Typography variant="subtitle1" sx={{ color: theme.palette.text.secondary, mb: 2 }}>
                ¿Te interesa alguno de nuestros productos? Comunícate vía:
              </Typography>
              <Button
                component="a"
                href="mailto:ventas@hydroluz.com.ec"
                variant="contained"
                sx={{
                  backgroundColor: accentOrange,
                  color: '#fff',
                  fontWeight: 700,
                  mr: 2,
                  '&:hover': { backgroundColor: '#e68a00' }
                }}
              >
                Enviar correo
              </Button>
              <Button
                component="a"
                href="tel:+593991911882"
                variant="outlined"
                sx={{
                  borderColor: primaryBlue,
                  color: primaryBlue,
                  fontWeight: 700,
                  '&:hover': { backgroundColor: '#f0f8ff' }
                }}
              >
                Llamar ahora
              </Button>
            </Box>
          </motion.div>
        </Grid>
      </Grid>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ delay: 1.2, duration: 0.8 }}
      >
        <Box
          sx={{
            mt: 8,
            p: 4,
            textAlign: 'center',
            borderRadius: 2,
            bgcolor: '#f7f7f7'
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 700, color: primaryBlue, mb: 2 }}>
            Envío rápido y seguro en todo Ecuador
          </Typography>
          <Typography sx={{ color: '#555' }}>
            Con Hydroluz, tu pedido llega en tiempo récord. ¡Garantizado!
          </Typography>
        </Box>
      </motion.div>
    </Box>
  );
}
